/**
 * Base class for client-server processing
 * 
 * Helper:https://github.com/axios/axios/issues/897#issuecomment-343715381
 */
import Vue from 'vue'
import CONFIG from '@/constants/config.js';
import i18n from '@/locale/i18n'
import { setupCache } from 'axios-cache-adapter'

export default class{

    static mockIfDebug(oriPromise){

        if(CONFIG.DEBUG){
            return new Promise((resolve) => {
                setTimeout(()=>{
                    resolve();
                },500);
            });
        }

        return oriPromise;
    }

    static mockDebugUrl(url){
        return url;
    }

    static userIsLoggedIn(){
        try{
            return JSON.parse(localStorage.getItem('app-storage')).settings.app_logged_in;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static getUserToken(){
        try{
            return JSON.parse(localStorage.getItem('app-storage')).settings.app_token;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static getUserLanguage(){
        try{
            let defaultLang= (i18n && !Vue._.isEmpty(i18n.locale))?i18n.locale: process.env.VUE_APP_LOCALE;
            return JSON.parse(localStorage.getItem('app-storage')).settings.app_locale || defaultLang;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static getUserEvent(){
        try{
            return JSON.parse(localStorage.getItem('app-storage')).events.selected_event_id;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static getGametype(){
        try{
            return JSON.parse(localStorage.getItem('app-storage')).events.gametype;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static getAppIdentifier(){
        try{
            let app_id_of_user= JSON.parse(localStorage.getItem('app-storage')).settings.app_identifier;
            let app_id_of_event= JSON.parse(localStorage.getItem('app-storage')).events.app_identifier;
            return (!Vue._.isEmpty(app_id_of_event))?app_id_of_event:app_id_of_user;
        }catch(ex){
            console.log(ex);
        }
        return false;
    }

    static extendByDefaultParams(params){
        let defaultParams=[];
        defaultParams[CONFIG.PARAM_NAME_APP_ID]=this.getAppIdentifier() || CONFIG.APP_IDENTIFIER;
        defaultParams[CONFIG.PARAM_NAME_GAMETYPE_ID]=this.getGametype();
        defaultParams[CONFIG.PARAM_NAME_TOKEN]=this.getUserToken();
        defaultParams[CONFIG.PARAM_NAME_LANGUAGE]=this.getUserLanguage();
        defaultParams[CONFIG.PARAM_NAME_PLATFORM]=CONFIG.APP_PLATFORM;
        defaultParams[CONFIG.PARAM_NAME_APP_VERSION]=CONFIG.APP_VERSION;
        defaultParams[CONFIG.PARAM_THROW_ERROR]=true;

        /*
        let eventId=this.getUserEvent();
        if(eventId){
            defaultParams[CONFIG.PARAM_NAME_EVENT_ID]=eventId;
        }*/
        
        return Vue._.merge(params,defaultParams);
    }

    static handleUnauthorizationIf403(error,url,data){
        if(error && error.response){
            console.log(url);
            if(error.response.data){
                console.warn(error.response.data.errors);
                if(Vue._.includes(error.response.data.errors,"event_is_inactive")){
                    let eventId=(data)?data.eventId:null;
                    window.location = `/event/${eventId}/inactive`;
                }else if (Vue._.includes(error.response.data.errors,"cant_play_again")){
                    //const search = new Q(location.search);
                    //search.setParam('error', 'cant_play_again');
                    //search.setBrowserUrl();
                    return;
                }
            }
            if(error.response.status==403 || error.response.status==401){
                if(this.$router){
                    this.$router.push({ path: `/login`});
                }else if(window.location.pathname !="/login"){
                    window.location = "/login";
                }
            }
        }
    }

    // axiosConfig is merged into the request, e.g. {cache:{ignoreCache:true}} to bypass the 30 s GET cache
    static get(url,data,typeName,redirectToLoginIfError=true,axiosConfig={}){
        return this.mockIfDebug(new Promise((resolve,reject) => {

            // Create `axios-cache-adapter` instance
            const cache = setupCache({
                maxAge:  30000
            })

            const api = Vue.axios.create({
                adapter: cache.adapter
            });

            api(Vue._.merge({
                url:this.mockDebugUrl(url),
                method: "get",
                params: this.extendByDefaultParams(data),
                baseURL: CONFIG.BASE_URL,
                timeout:CONFIG.REQUEST_TIMEOUT,
                withCredentials: false//(process.env.NODE_ENV === 'development'),
              },axiosConfig)).then(async (response)=>{
                // const length = await cache.store.length();

                // console.log('Cache store length:', length);
                // console.log(`${typeName} success`);
                let data=(response)?response.data:response;
                resolve(data);
            })
            .catch( (error) =>{
                console.log(`${typeName} error`);
                console.warn(error);
                reject(error);
                if(redirectToLoginIfError){
                    this.handleUnauthorizationIf403(error,url,data);
                }
            });
            /*
            Vue.axios.defaults.withCredentials = true;
            Vue.axios.get(this.mockDebugUrl(url), {params: data})
            .then((response)=>{
                console.log(typeName+'success');
                resolve(response);
            })
            .catch( (error) =>{
                console.log(typeName+'error');
                console.warn(error);
                reject(error);
            });*/
        }));
    }
    static delete(url,data,typeName){
        return this.mockIfDebug(new Promise((resolve,reject) => {
            Vue.axios.delete(this.mockDebugUrl(url), {
                withCredentials: false, //(process.env.NODE_ENV === 'development'),
                baseURL: CONFIG.BASE_URL,
                timeout:CONFIG.REQUEST_TIMEOUT,
                data: this.extendByDefaultParams(data),
            })
            .then((response)=>{
                // console.log(`${typeName} success`);
                let data=(response)?response.data:response;
                resolve(data);
            })
            .catch( (error) =>{
                console.log(`${typeName} error`);
                console.warn(error);
                reject(error);
                this.handleUnauthorizationIf403(error,url,data);
            });
        }));
    }

    static post(url,data,typeName,useParams=false,redirectToLoginIfError=true,timeout=CONFIG.REQUEST_TIMEOUT){
        return this.mockIfDebug(new Promise((resolve,reject) => {
        Vue.axios(this.mockDebugUrl(url), {
            method: "post",
            data: this.extendByDefaultParams(data),
            params:(useParams)?data:null,
            baseURL: CONFIG.BASE_URL,
            timeout:timeout,
            withCredentials: false,
            
          }).then((response)=>{
            // console.log(`${typeName} success`);
            let data=(response)?response.data:response;
            resolve(data);
        })
        .catch( (error) =>{
            console.log(`${typeName} error`);
            console.warn(error);
            reject(error);
            if(redirectToLoginIfError){
                this.handleUnauthorizationIf403(error,url,data);
            }
        });
    }));
    }

    static upload(url,config,data,formData,typeName,redirectToLoginIfError=true){
        return this.mockIfDebug(new Promise((resolve,reject) => {
        Vue.axios(this.mockDebugUrl(url), {
            method: "post",
            data: formData,
            params:this.extendByDefaultParams(data),
            baseURL: CONFIG.BASE_URL,
            timeout:CONFIG.REQUEST_TIMEOUT,
            withCredentials: false,
            ...config
            
          }).then((response)=>{
            // console.log(`${typeName} success`);
            let data=(response)?response.data:response;
            resolve(data);
        })
        .catch( (error) =>{
            console.log(`${typeName} error`);
            console.warn(error);
            reject(error);
            if(redirectToLoginIfError){
                this.handleUnauthorizationIf403(error,url,data);
            }
        });
    }));
    }

    static put(url,data,typeName,redirectToLoginIfError=true){
        return this.mockIfDebug(new Promise((resolve,reject) => {
            Vue.axios(this.mockDebugUrl(url), {
                method: "put",
                data: this.extendByDefaultParams(data),
                baseURL: CONFIG.BASE_URL,
                timeout:CONFIG.REQUEST_TIMEOUT,
                withCredentials: false//(process.env.NODE_ENV === 'development')
            }).then((response)=>{
                // console.log(`${typeName} success`);
                resolve(response);
            })
            .catch( (error) =>{
                console.log(`${typeName} error`);
                console.warn(error);
                reject(error);
                if(redirectToLoginIfError){
                    this.handleUnauthorizationIf403(error,url,data);
                }
            });
        }));
    }

    static dateInXDays(days) {
        let result = new Date();
        result.setDate(result.getDate() + days);
        return result;
    }
}